<template>
    <div class="container">
        <el-form ref="formRef" :rules="rules" :model="form" label-width="150px" >
            <div class="formTitle">修改Google秘钥</div>
            <el-row>
                <el-form-item label="原始秘钥验证码" prop="oldPwd">
                    <el-input type="password" placeholder="原始秘钥验证码" v-model="form.oldPwd" show-password></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="新秘钥验" prop="newKey">
                    <span style="margin-right:20px;">{{form.newKey}}</span><el-button @click="getNewKey" type="primary">获取新秘钥</el-button>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="新秘钥验证码" prop="newPwd">
                    <el-input type="password" placeholder="新秘钥验证码" v-model="form.newPwd" show-password></el-input>
                </el-form-item>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="onSubmit" type="primary">提交</el-button>
            <el-button @click="onCancel">取消</el-button>
        </div>
    </div>
</template>

<script>
import {userServiceApi} from '@/api/api-auth';
import {checkPwd} from  '@/assets/js/validator';
import {clearUser } from '@/assets/js/user';

export default {
    data(){
        return {
            form:{ oldPwd:"", newKey:"", newPwd:"" },
            rules: {
                oldPwd: [{ required: true, trigger: 'blur', message:"不能为空" }],
                newKey: [{ required: true, trigger: 'blur', message:"不能为空"}],
                newPwd: [{ required: true, trigger: 'blur', message:"不能为空" }],
            }
        }
    },
    methods:{
        getNewKey(){
            userServiceApi.getNewKey().then(res=>{
                this.form.newKey = res.data;
            })
        },
        onSubmit(){
            this.$refs.formRef.validate((valid)=>{
                if(!valid){
                    return;
                }
                userServiceApi.resetMyKey({oldPwd:this.form.oldPwd,newKey:this.form.newKey,newPwd:this.form.newPwd}).then(res=>{
                    if(res.result){
                        this.$message.success("修改成功");
                        setTimeout(()=>{
                            clearUser();
                            this.$router.push('/login');
                        },1000)
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            });
        },
        onCancel(){
            this.form = { oldPwd:"", newKey:"", newPwd:"" }
        },
    }
}
</script>

<style lang='less' scoped>
    .el-form{
        width: 430px;
        margin:0 auto;
    }
    .formTitle{
        font-weight:800px;
        font-size:25px;
        text-align:center;
        margin:0px 0px 30px 0px;
        padding-top:20px;
    }
</style>